<template>
  <input
    type="text"
    v-model="displayValue"
    @blur="blurTextbox($event)"
    @focus="focusTextbox($event)"
    @keypress="isNumber($event)"
    @change="formatNumber($event)"
    @keyup="onKeyup($event)"
  />
</template>
<script>
const dotCharacter = ".";
export default {
  data: function() {
    return {
      isInputActive: false
    };
  },
  props: {
    fixDecimal: {
      type: String,
      default: "0"
    },
    value: {
      type: String,
      default: ""
    }
  },
  methods: {
    isNumber(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (this.isNotNumberChar(charCode) || this.isNotNumberValue()) {
        evt.preventDefault();
      }
      if (this.value === dotCharacter) {
        this.value = "";
      }
      this.$emit("keypress", evt);
    },
    isNotNumberChar(charCode) {
      if (
        this.charCodeIncorrect(charCode) &&
        (this.isDecimal(charCode) ||
          this.isFirstDotChar(charCode) ||
          +this.fixDecimal === 0)
      ) {
        return true;
      }
      return false;
    },
    isFirstDotChar(charCode) {
      return !this.value && charCode === 46;
    },
    charCodeIncorrect(charCode) {
      return charCode > 31 && (charCode < 48 || charCode > 57);
    },
    isDecimal(charCode) {
      const isDecimalEntered =
        this.value && this.value.indexOf(dotCharacter) !== -1;
      return +this.fixDecimal !== 0 && (charCode !== 46 || isDecimalEntered);
    },
    isNotNumberValue() {
      if (this.value) {
        const number = this.value.split(dotCharacter);
        const caratPos = this.getSelectionStart(this);
        const dotPos = this.value.indexOf(dotCharacter);
        if (caratPos > dotPos && dotPos > -1 && number[1].length > 0) {
          return true;
        }
      }
      return false;
    },
    getSelectionStart(o) {
      if (o.createTextRange) {
        const r = document.selection.createRange().duplicate();
        r.moveEnd("character", o.value.length);
        if (r.text === "") {
          return o.value.length;
        }
        return o.value.lastIndexOf(r.text);
      } else {
        return o.selectionStart;
      }
    },
    formatNumber(evt) {
      let newValue = parseFloat(this.value.replace(/[^\d.]/g, ""));
      if (isNaN(newValue)) {
        newValue = this.value;
      } else {
        const rounding =
          +this.fixDecimal === 0 ? 10 : Math.pow(10, +this.fixDecimal);
        newValue = Math.round(newValue * rounding) / rounding;
      }
      this.$emit("input", newValue.toString());
      this.$emit("change", evt);
    },
    focusTextbox(evt) {
      this.isInputActive = true;
      this.$emit("focus", evt);
    },
    blurTextbox(evt) {
      this.isInputActive = false;
      this.$emit("blur", evt);
    },
    onKeyup(event) {
      this.$emit("keyup", event);
      this.$nextTick(() => {
        if (event.keyCode === 9) {
          event.target.select();
        }
      });
    }
  },
  computed: {
    displayValue: {
      get: function() {
        if (!this.value) {
          return this.value;
        }
        if (this.isInputActive) {
          if (this.value === dotCharacter) {
            return "";
          }
          return this.value.toString();
        } else {
          if (this.value === dotCharacter) {
            return "";
          }
          return this.value.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
        }
      },
      set: function(modifiedValue) {
        if (modifiedValue === dotCharacter) {
          this.$emit("input", "");
        } else {
          this.$emit("input", modifiedValue);
        }
      }
    }
  }
};
</script>
